import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7001Model } from '../kymw7001.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { GetTargetListByFeatureGoodsSelectionResponse } from './get-target-list-by-feature-goods-selection.service';

// レスポンス構造
export type CheckFeatureGoodsSelectionResponse = {
  PCode: string;
  ItemCode: string;
}[];

/**
 * 特集商品選定チェックサービス
 * @export CheckFeatureGoodsSelectionService
 * @class CheckFeatureGoodsSelectionService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class CheckFeatureGoodsSelectionService extends PlessJsonResponderSub<CheckFeatureGoodsSelectionResponse> {
  model: KYMW7001Model;
  list: GetTargetListByFeatureGoodsSelectionResponse;
  private calbak: (data: CheckFeatureGoodsSelectionResponse) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CheckFeatureGoodsSelectionService
   */
  private getBody(): PlessRequest {

    const searchObj = {
      CheckFeature: {
        condition: {
          OrderCode: this.model.orderCode,
          MediumType: this.model.mediumType,
          FeatureCode: this.model.featureCode
        },
        combination: this.list.map(item => ({
          condition: {
            PCode: item.PCode,
            ItemCode: item.ItemCode
          } 
        }))
      }
    }

    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof CheckFeatureGoodsSelectionService
   */
  execute(model: KYMW7001Model, list: GetTargetListByFeatureGoodsSelectionResponse, 
            f?: (data: CheckFeatureGoodsSelectionResponse) => void): void {
    this.model = model;
    this.list = list;
    if (f) this.calbak = f;
    this.send('checkFeatureGoodsSelection', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CheckFeatureGoodsSelectionService
   */
  success(data: CheckFeatureGoodsSelectionResponse) {
    if (this.calbak) this.calbak(data);
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
